var map = {
	"./malta-1.jpg": 191,
	"./malta-2.jpg": 192,
	"./malta-3.jpg": 193,
	"./malta-4.jpg": 194,
	"./malta-5.jpg": 195,
	"./malta-6.jpg": 196,
	"./malta-7.jpg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;